// A function to safely check a chain of nested properties in an object, use instead of lodash/get. Pass a callback function that contains the object you want to check, it should fail gracefully and return undefined if there is an error.
// Usage: getSafe(() => object.property.person.name)

export default function getSafe(cb) {
  try {
    return cb();
  } catch (e) {
    return undefined;
  }
}
